import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

function Status(props) {
    const { status } = props;
    const statusStyles = {
        New: { color: 'rgb(35, 134, 222)' },
        Open: { color: 'rgb(14, 211, 59)' },
        Closed: { color: 'rgb(219, 52, 70)' },
    };
    return (
        <div
            style={{
                fontFamily: 'Arial',
                fontSize: '14px',
                fontWeight: 'normal',
                display: 'flex',
                letterSpacing: '0em',
                height: '30px',
                padding: '0 5px',
            }}
        >
            {status && (
                <div
                    style={{
                        background: statusStyles[status].color,
                        border: '3px solid rgb(163, 192, 177)',
                        display: 'flex',
                        width: '60px',
                        height: '30px',
                        color: 'white',
                        alignItems: 'center',
                        borderRadius: '15px',
                        justifyContent: 'center',
                    }}
                >
                    {status}
                </div>
            )}
        </div>
    );
}

export function OfferingTileV2(props) {
    const { fund, link, amount, fraction } = props;
    const navigate = useNavigate();
    const [isHovered, setIsHovered] = useState(false);
    return (
        <div
            style={{
                height: amount ? 310 : 280,
                display: 'flex',
                flexDirection: 'column',
                border: '1px solid rgb(133, 133, 133)',
                borderRadius: '8px',
                padding: '12px',
                width: 200,
                cursor: 'pointer',
                background: isHovered ? '#f5f5f5' : 'white',
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={() => {
                navigate(link);
            }}
        >
            <div
                style={{
                    width: '100%',
                    height: 100,
                }}
            >
                <img
                    style={{ width: '100%', height: '100%' }}
                    src={
                        fund.img_src ||
                        'https://static.wixstatic.com/media/1e11ac_c9300dd8e54c4e5397141c2246af71c6~mv2.png/v1/fill/w_948,h_1226,al_t,q_90,usm_0.66_1.00_0.01,enc_auto/1e11ac_c9300dd8e54c4e5397141c2246af71c6~mv2.png'
                    }
                ></img>

                <div
                    style={{
                        fontFamily: 'Arial',
                        fontSize: '17px',
                        fontWeight: 'normal',
                        lineHeight: '24px',
                        display: 'flex',
                        letterSpacing: '0em',
                        padding: '5px',
                        height: '60px',
                        alignItems: 'center',
                    }}
                >
                    {fund.name}
                </div>

                <Status status={fund.offering_status} />

                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        flexDirection: 'row',
                        padding: '5px',
                    }}
                >
                    <div>Min. investment</div>
                    <div>
                        {fund.min_investment ? `$${fund.min_investment}K` : ''}
                    </div>
                </div>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        flexDirection: 'row',
                        padding: '5px',
                        paddingTop: '0px',
                    }}
                >
                    <div>Target term</div>
                    <div>
                        {fund.target_term ? `${fund.target_term} months` : ''}
                    </div>
                </div>

                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        flexDirection: 'row',
                        padding: '5px',
                        paddingTop: '0px',
                    }}
                >
                    <div>Type</div>
                    <div>{fund.type}</div>
                </div>

                {/*amount && (
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            flexDirection: 'row',
                            padding: '5px',
                            paddingTop: '0px',
                        }}
                    >
                        <div>{amount}</div>
                        <div>{fraction}</div>
                    </div>
                )*/}
            </div>
        </div>
    );
}
